import { render, staticRenderFns } from "./found-problem.vue?vue&type=template&id=19850bcc&scoped=true"
import script from "./found-problem.vue?vue&type=script&lang=js"
export * from "./found-problem.vue?vue&type=script&lang=js"
import style0 from "./found-problem.vue?vue&type=style&index=0&id=19850bcc&prod&lang=css"
import style1 from "./found-problem.vue?vue&type=style&index=1&id=19850bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19850bcc",
  null
  
)

export default component.exports